import Api from './ApiContracts';

export default {
  async getReportsGroup(nameApp) {
    const response = await Api.getReportsGroup(nameApp);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  },
  async executeReport(report, params = null) {
    const tempReport = report;
    if (params != null) {
      tempReport.Parametros = params;
    }
    const response = await Api.executeReport(tempReport);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  },
};
